import videojs from 'video.js';
import { QueryStringParamProvider } from '../../implementations/player-page/helpers.js';
import './guided.css';

export class GuidedPluginStub extends videojs.getPlugin('plugin') {
    constructor(player, options) {
        super(player, options);

        player.loader().onLoadPresentation(onLoadPresentation.bind(player));
    }
}

function shouldLoad(presentationId, playCoverData, presentationData) {
    const paramProvider = new QueryStringParamProvider(location.search);
    return paramProvider.getParam("guided") === 'true';
}

async function onLoadPresentation(presentationId, playCoverData, presentationData) {
    const player = this;

    if (shouldLoad(...arguments)) {
        if (!videojs.getPlugin('guided')) {
            const { GuidedPlugin } = await import(/* webpackChunkName: 'guided' */ './guided.js');
            player.registerPlugin('guided', GuidedPlugin);
        }

        player.guided().init();
    }
}